export default "__VITE_ASSET__ChXEwtUz__"